
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(32|59)9$/.test(chunkId);
},
rootOutputDir: "",

    };
}
